import { useEffect } from "react";
import { useLocation } from "wouter";
export default function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    let observer: MutationObserver | undefined;
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const clear = () => { observer?.disconnect(); clearTimeout(timeout); };
    const scroll = () => {
      clear();
      if (!window.location.hash) { window.scrollTo({top:0,left:0,behavior:"instant" as ScrollBehavior}); return; }
      let id: string;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const find = () => {
        const node = document.getElementById(id);
        if (!node) return false;
        node.scrollIntoView({behavior: "instant" as ScrollBehavior, block:"start"});
        clear();
        return true;
      };
      if (!find()) {
        observer = new MutationObserver(find);
        observer.observe(document.getElementById("main-content") || document.body,{subtree:true,childList:true});
        timeout = setTimeout(clear,10000);
      }
    };
    scroll();
    window.addEventListener("hashchange",scroll);
    return () => { clear(); window.removeEventListener("hashchange",scroll); };
  }, [location]);
  return null;
}
